import { useState } from "react";
import { CalendarClock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatErr } from "@/lib/api";

export const EXPIRING = new Set(["business_license", "insurance", "good_standing"]);

export function ExpiryDialog({ doc, onClose, onSaved }) {
  const [d, setD] = useState(doc?.expires_on || "");
  const [busy, setBusy] = useState(false);
  if (!doc) return null;
  const save = async (value) => {
    setBusy(true);
    try {
      const r = await api.put(`/documents/${doc.doc_id}/expiry`, { expires_on: value || null });
      toast.success(value ? "Added to your Compliance Calendar. We'll email you 30 and 7 days before it expires." : "Saved with no expiry date");
      onSaved?.(r.data); onClose();
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm w-[calc(100%-2rem)]" data-testid="expiry-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><CalendarClock className="h-5 w-5 text-emerald-600" />When does it expire?</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-600 break-words">{doc.filename}</p>
        <Input type="date" value={d} onChange={(e) => setD(e.target.value)} className="h-11" data-testid="expiry-date-input" />
        <div className="flex flex-col sm:flex-row gap-2">
          <Button onClick={() => save(d)} disabled={busy || !d} className="flex-1 h-11 bg-emerald-600 hover:bg-emerald-700" data-testid="expiry-save">{busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Add to calendar</Button>
          <Button variant="outline" onClick={() => save("")} disabled={busy} className="h-11" data-testid="expiry-none">No expiry date</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
